import type * as React from 'react';
import { rem } from '../../lib/rem';

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: `${rem(7)} ${rem(10)}`,
  borderRadius: rem(5),
  border: '1px solid var(--bd)',
  background: 'var(--ib)',
  color: 'var(--tx)',
  fontSize: 'var(--font-size-base)',
};
export const labelStyle: React.CSSProperties = {
  fontSize: 'var(--font-size-sm)',
  fontWeight: 600,
  color: 'var(--tm)',
  marginBottom: 'var(--space-1)',
};
export const cardStyle: React.CSSProperties = {
  background: 'var(--sf)',
  borderRadius: 'var(--radius-lg)',
  border: '1px solid var(--bd)',
  padding: `var(--space-4) ${rem(20)}`,
};
